export default __webpack_public_path__ + "assets/images/2d06b3170138d1c0bb22ee9d1fc2161b.svg";